import { render } from "./MainDeterminant.vue?vue&type=template&id=375f0138&scoped=true&ts=true"
import script from "./MainDeterminant.ts?vue&type=script&lang=ts&external"
export * from "./MainDeterminant.ts?vue&type=script&lang=ts&external"

import "./MainDeterminant.scss?vue&type=style&index=0&id=375f0138&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375f0138"]])

export default __exports__